<template lang="pug">
.wrapper.wrapper--sidebar
    aside.wrapper--sidebar__sidebar
        //- .sidebar-inner
            .sidebar-inner__header.p-3
                .subheader
                    .list.flex.items-center.justify-between.mb-2
                        span No. Plat
                        strong.monospace AB1234XZY
                    .list.flex.items-center.justify-between.mb-2
                        span NIK
                        strong.monospace -
                    .list.flex.items-center.justify-between.mb-2
                        span KTP
                        strong.monospace -

                    .flex.justify-end.mb-4.w-full
                        a.btn-primary-o.py-1.px-2.w-full.text-center save as target
        Sidebar(:isKey="isKey")
        //- Sidebar

    section.wrapper--sidebar__content
        //- Header Global
        HeaderGlobal(HeaderGlobalHeading="Vehicles" :HeaderGlobalBreadcrumb="breadcrumb")

        template(v-if="isKey && Object.keys(vehicles).length > 0")
            .box(v-for="(vehicle, index) in vehicles" :key="index")
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Plat Nomor : 
                                span {{ vehicle.NO_POLISI ? vehicle.NO_POLISI : '-' }}
                        .header-cta
                            
                .box__body.p-4
                    .block.mb-4
                        .flex.flex-wrap.-mx-4   
                            .block.px-4(class="w-1/4")
                                .block.mb-4
                                    span.text-light Pemilik
                                    h3.monospace {{ vehicle.PEMILIK ? vehicle.PEMILIK : '-' }}
                                .block.mb-4
                                    span.text-light Alamat
                                    h3.monospace {{ vehicle.ALAMAT ? vehicle.ALAMAT : '-' }}
                                .block.mb-4
                                    span.text-light Alamat 2
                                    h3.monospace {{ vehicle.ALAMAT2 ? vehicle.ALAMAT2 : '-' }}
                                .block.mb-4
                                    span.text-light Kode Lokasi
                                    h3.monospace {{ vehicle.KODE_LOKASI ? vehicle.KODE_LOKASI : '-' }}
                                .block.mb-4
                                    span.text-light No. KTP
                                    h3.monospace {{ vehicle.NO_KTP ? vehicle.NO_KTP : '-' }}
                                .block.mb-4
                                    span.text-light No. KK
                                    h3.monospace {{ vehicle.NO_KK ? vehicle.NO_KK : '-' }}
                                .block.mb-4
                                    span.text-light No. HP
                                    h3.monospace {{ vehicle.NO_HP ? vehicle.NO_HP : '-' }}
                                .block.mb-4
                                    span.text-light Nopol Lama
                                    h3.monospace {{ vehicle.NOPOL_LAMA ? vehicle.NOPOL_LAMA : '-' }}
                                .block.mb-4
                                    span.text-light Status Pemilik
                                    h3.monospace {{ vehicle.STSPEMILIK ? vehicle.STSPEMILIK : '-' }}

                            .block.px-4(class="w-1/4")
                                .block.mb-4
                                    span.text-light Merk
                                    h3.monospace {{ vehicle.MERK ? vehicle.MERK : '-' }}
                                .block.mb-4
                                    span.text-light Jenis Kendaraan
                                    h3.monospace {{ vehicle.JENIS_KEND ? vehicle.JENIS_KEND : '-' }}
                                .block.mb-4
                                    span.text-light Golongan Kendaraan
                                    h3.monospace {{ vehicle.GOL_KEND ? vehicle.GOL_KEND : '-' }}
                                .block.mb-4
                                    span.text-light Kode Jenis
                                    h3.monospace {{ vehicle.KODE_JENIS ? vehicle.KODE_JENIS : '-' }}
                                .block.mb-4
                                    span.text-light Kode Golongan
                                    h3.monospace {{ vehicle.KODE_GOLONGAN ? vehicle.KODE_GOLONGAN : '-' }}
                                .block.mb-4
                                    span.text-light Tipe
                                    h3.monospace {{ vehicle.TIPE ? vehicle.TIPE : '-' }}
                                .block.mb-4
                                    span.text-light Model
                                    h3.monospace {{ vehicle.MODEL ? vehicle.MODEL : '-' }}
                                .block.mb-4
                                    span.text-light Warna
                                    h3.monospace {{ vehicle.WARNA ? vehicle.WARNA : '-' }}
                                .block.mb-4
                                    span.text-light BBM
                                    h3.monospace {{ vehicle.BBM ? vehicle.BBM : '-' }}

                            .block.px-4(class="w-1/4")
                                .block.mb-4
                                    span.text-light No. Rangka
                                    h3.monospace {{ vehicle.NO_RANGKA ? vehicle.NO_RANGKA : '-' }}
                                .block.mb-4
                                    span.text-light No. Mesin
                                    h3.monospace {{ vehicle.NO_MESIN ? vehicle.NO_MESIN : '-' }}
                                .block.mb-4
                                    span.text-light Rakit
                                    h3.monospace {{ vehicle.RAKIT ? vehicle.RAKIT : '-' }}
                                .block.mb-4
                                    span.text-light Silinder
                                    h3.monospace {{ vehicle.SILINDER ? vehicle.SILINDER : '-' }}
                                .block.mb-4
                                    span.text-light TNKB
                                    h3.monospace {{ vehicle.TNKB ? vehicle.TNKB : '-' }}
                                .block.mb-4
                                    span.text-light Jumlah AS
                                    h3.monospace {{ vehicle.JML_AS ? vehicle.JML_AS : '-' }}
                                .block.mb-4
                                    span.text-light Jumlah Beban
                                    h3.monospace {{ vehicle.JML_BEBAN ? vehicle.JML_BEBAN : '-' }}
                                .block.mb-4
                                    span.text-light No. Faktur
                                    h3.monospace {{ vehicle.NO_FAKTUR ? vehicle.NO_FAKTUR : '-' }}
                                .block.mb-4
                                    span.text-light Tgl Faktur
                                    h3.monospace {{ vehicle.TGL_FAKTUR ? vehicle.TGL_FAKTUR : '-' }}

                            .block.px-4(class="w-1/4")
                                .block.mb-4
                                    span.text-light No. BPKB
                                    h3.monospace {{ vehicle.NO_BPKB ? vehicle.NO_BPKB : '-' }}
                                .block.mb-4
                                    span.text-light Tgl BPKB
                                    h3.monospace {{ vehicle.TGL_BPKB ? vehicle.TGL_BPKB : '-' }}
                                .block.mb-4
                                    span.text-light Tgl STNK
                                    h3.monospace {{ vehicle.TGL_STNK ? vehicle.TGL_STNK : '-' }}
                                .block.mb-4
                                    span.text-light Tgl Pajak
                                    h3.monospace {{ vehicle.TGL_PAJAK ? vehicle.TGL_PAJAK : '-' }}
                                .block.mb-4
                                    span.text-light Tgl Daftar
                                    h3.monospace {{ vehicle.TGL_DAFTAR ? vehicle.TGL_DAFTAR : '-' }}
                                .block.mb-4
                                    span.text-light Jenis Daftar
                                    h3.monospace {{ vehicle.JENIS_DAFTAR ? vehicle.JENIS_DAFTAR : '-' }}
                                .block.mb-4
                                    span.text-light Kode SAMSAT
                                    h3.monospace {{ vehicle.KD_SAMSAT ? vehicle.KD_SAMSAT : '-' }}
                                .block.mb-4
                                    span.text-light Kode POLDA
                                    h3.monospace {{ vehicle.KD_POLDA ? vehicle.KD_POLDA : '-' }}
                                .block.mb-4
                                    span.text-light Tgl Mati YAD
                                    h3.monospace {{ vehicle.TGL_MATI_YAD ? vehicle.TGL_MATI_YAD : '-' }}
                                .block.mb-4
                                    span.text-light SAMSAT Bayar
                                    h3.monospace {{ vehicle.SAMSAT_BAYAR ? vehicle.SAMSAT_BAYAR : '-' }}
        .box(v-else)
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Plat Nomor : 
                            span AD-2058-LO (this is template)
                    .header-cta
                        
            .box__body.p-4
                .block.mb-4
                    .flex.flex-wrap.-mx-4   
                        .block.px-4(class="w-1/4")
                            .block.mb-4
                                span.text-light Pemilik
                                h3.monospace ABDUL HAMID
                            .block.mb-4
                                span.text-light Alamat
                                h3.monospace KRASAK RT 01/16 PLANGGU TRUCUK KLATEN
                            .block.mb-4
                                span.text-light Alamat 2
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode Lokasi
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. KTP
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. KK
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. HP
                                h3.monospace -
                            .block.mb-4
                                span.text-light Nopol Lama
                                h3.monospace -
                            .block.mb-4
                                span.text-light Status Pemilik
                                h3.monospace -

                        .block.px-4(class="w-1/4")
                            .block.mb-4
                                span.text-light Merk
                                h3.monospace HONDA/ACB2J22B03 A/T
                            .block.mb-4
                                span.text-light Jenis Kendaraan
                                h3.monospace C1 - SEPEDA MOTOR 250 CC
                            .block.mb-4
                                span.text-light Golongan Kendaraan
                                h3.monospace C1 - Golongan C1
                            .block.mb-4
                                span.text-light Kode Jenis
                                h3.monospace C1
                            .block.mb-4
                                span.text-light Kode Golongan
                                h3.monospace C1
                            .block.mb-4
                                span.text-light Tipe
                                h3.monospace -
                            .block.mb-4
                                span.text-light Model
                                h3.monospace -
                            .block.mb-4
                                span.text-light Warna
                                h3.monospace WHITE SILVER
                            .block.mb-4
                                span.text-light BBM
                                h3.monospace Bensin

                        .block.px-4(class="w-1/4")
                            .block.mb-4
                                span.text-light No. Rangka
                                h3.monospace MH1JFK11XEK195679
                            .block.mb-4
                                span.text-light No. Mesin
                                h3.monospace JFK1E1192664
                            .block.mb-4
                                span.text-light Rakit
                                h3.monospace 2014
                            .block.mb-4
                                span.text-light Silinder
                                h3.monospace -
                            .block.mb-4
                                span.text-light TNKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jumlah AS
                                h3.monospace -
                            .block.mb-4
                                span.text-light Jumlah Beban
                                h3.monospace -
                            .block.mb-4
                                span.text-light No. Faktur
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Faktur
                                h3.monospace -

                        .block.px-4(class="w-1/4")
                            .block.mb-4
                                span.text-light No. BPKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl BPKB
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl STNK
                                h3.monospace 16/11/2018
                            .block.mb-4
                                span.text-light Tgl Pajak
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Daftar
                                h3.monospace 16/11/2018
                            .block.mb-4
                                span.text-light Jenis Daftar
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode SAMSAT
                                h3.monospace -
                            .block.mb-4
                                span.text-light Kode POLDA
                                h3.monospace -
                            .block.mb-4
                                span.text-light Tgl Mati YAD
                                h3.monospace -
                            .block.mb-4
                                span.text-light SAMSAT Bayar
                                h3.monospace 0400128

</template>

<script>
import { mapState } from 'vuex';
import { decrypt } from '@/util/crypto';
import Sidebar from '@/components/shell/sidebar/Sidebar.vue';
import HeaderGlobal from '@/components/HeaderGlobal.vue';

export default {
    name: 'result',
    components: {
        Sidebar,
        HeaderGlobal,
    },
    data: function() {
        return {
            // isKey is for development only
            // isKey: this.$route.params.key!==undefined ? true : false,
            // isKey: this.key!==undefined ? true : false,
            // key: this.$route.params.key,
            breadcrumb: [
                {
                    name: 'Vehicles',
                    url: '/vehicles',
                },
            ],
        };
    },
    computed: {
        ...mapState([
          'vehicles',
        ]),
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        }
    },
    watch: {
        key() {},
        isKey() {},
    },
    methods: {
        getData() {
            if (this.isKey) {
                let decrypt_data = decrypt(this.key);
                decrypt_data = decrypt_data.split('&&');
                // console.log(decrypt_data);
                var key = decrypt_data[0];
                // var type = decrypt_data[1];
                this.$store.dispatch('getVehicles', [key]);
            }
        },
    },
    mounted() {
        // console.log('================== in Vehicles.vue');
        this.getData();
    },
}
</script>

<style lang="sass">

</style>


